<template>
  <a-drawer :maskClosable="false" width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose"
    :destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />
    <a-form-model ref="form" :model="form">
      <a-form-model-item label="作品名称" prop="workName" v-if="showIdIndex == 2 || showIdIndex == 3">
        <a-input v-model="form.workName" placeholder="请输入" :maxLength="10" />
      </a-form-model-item>
      <template v-if="showIdIndex !== 3">
        <!-- <a-form-model-item label="场景名称" prop="sceneName">
          <a-input v-model="form.sceneName" placeholder="请输入" :maxLength="10" />
        </a-form-model-item> -->
        <!-- <div class="form_sub">
          <a-button type="primary" @click="handleVrAdd" v-if="showId == 1 || showIdIndex == 2"> 新增 </a-button>
        </div>
        <div v-for="(item, index) in form.scenesEditParams" :key="index" class="form_con">
          <a-form-model-item label="场景名称" prop="sceneName">
            <a-input v-model="item.sceneName" placeholder="请输入" :maxLength="10" />
          </a-form-model-item>
          <div class="form_sub">
            <a-button type="danger" @click="handelDel(index)" v-if="showId == 1 || showIdIndex == 2"> 删除 </a-button>
          </div>
          <a-form-model-item label="全景图" prop="originalImageUrl" v-if="showId == 1 || showIdIndex == 2">
            <file-upload type="image" @input="getImg($event, item)" @backName="backName($event, item)"
              :file="item.originalImageUrl" :count="10" :isUpload="false" :pathSrc="true" pathSrc="library/ve-temporary"
              autoCropHeight="" autoCropWidth=""></file-upload>
          </a-form-model-item>
        </div> -->
        <div>
          <a-form-model-item label="全景图" prop="originalImageUrl" v-if="showId == 1 || showIdIndex == 2">
            <file-upload type="image" @input="getImg($event, originalImageUrl)"
              @backName="backName($event, originalImageUrl)" :file="originalImageUrl" :count="10" :isUpload="false"
              :pathSrc="true" pathSrc="library/ve-temporary" autoCropHeight="" autoCropWidth=""></file-upload>
          </a-form-model-item>
        </div>
      </template>
      <!-- <a-form-model-item label="排序" prop="sort">
        <a-input v-model="form.sort" placeholder="请输入" :maxLength="20" oninput="value=value.replace(/[^\d]/g,'')" />
      </a-form-model-item> -->
      <div class="bottom-control">
        <a-space>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>
<script>
import { mapGetters } from 'vuex'
import { ossSignature } from '@/api/system/user'
import { editSys, addObj, getObj } from '@/api/VR/vrWork'
import COS from 'cos-js-sdk-v5'
import FileUpload from '@/components/FileUpload/panoramaIndex.vue'
import moment from 'moment'
export default {
  name: 'CreateForm',
  components: { FileUpload },
  data() {
    return {
      submitLoading: false,
      showLoading: false,
      show: false,
      data: [],
      fileList: [],
      formTitle: '',
      isUploading: false,
      originalImageUrl: [],
      // 表单参数
      form: {
        scenesEditParams: [],
        scenesAddParam: [],
      },
      open: false,
      hour: [],
      hours: [],
      minute: [],
      minutes: [],
      showId: '',
      dataForm: {},
      showIdIndex: null,
    }
  },
  filters: {},
  created() {
    // console.log('statusOptions 显示隐藏', this.statusOptions)
  },
  computed: {
    ...mapGetters(['userTentant', 'infoUser']),
  },
  watch: {},
  methods: {
    onClose() {
      let that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          console.log(that.open, 'openopen')
          that.open = false
        },
        onCancel() { },
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    backName(e, item) {
      item.sceneName = e
    },
    // 点击删除
    handelDel(index) {
      this.form.scenesEditParams.splice(index, 1)
    },
    /**上传图片成功回调 */
    getImg(info, item) {
      console.log('info5555', info)
      this.form.scenesAddParam = info
      this.$set(this.form, 'scenesAddParam', info)
      console.log(this.form, 'formformform');
      if (this.showIdIndex == 1) {
        this.$set(this.form, 'scenesEditParams', info)
      }
      // console.log('itemitem', item)
      // item.originalImageUrl = info
      // item.extendS1 = info
      //   this.form[fieldName] = info
      //   this.form[fieldName] = info
      //   this.$refs.form.clearValidate(fieldName)
    },
    //  点击新增
    handleVrAdd() {
      let obj = false
      if (this.form.scenesEditParams.length) {
        this.form.scenesEditParams.forEach((v) => {
          if (!v.sceneName || !v.originalImageUrl) {
            obj = true
          }
        })
        if (obj) return this.$message.error('请先把数据填写完整在进行添加')
      }
      this.form.scenesEditParams.push({ originalImageUrl: '', extendS1: '', sceneName: '' })
    },
    // 取消按钮
    cancel() {
      this.onClose()
      this.reset()
    },
    // 获取文件名称
    generateCosKey(name, ext) {
      var ymd = moment().format('YYYYMMDD')
      var ymd = moment().format('YYYYMMDD_HHmmss_')
      var r = ('000000' + Math.random() * 1000000).slice(-6)
      var cosKey = name + `/file_${ymd}_${r}.${ext}`
      return cosKey
    },
    // 表单重置
    reset() {
      this.form = {
        scenesEditParams: [{ originalImageUrl: '', extendS1: '', sceneName: '' }],
      }
    },
    customRequest(options) {
      let that = this
      this.isUploading = true
      const { file, onProgress, onSuccess, onError } = options
      this.fileList = [file] // 仅保留最新的一个文件
      console.log(file, onProgress, onSuccess, onError, 'file, onProgress, onSuccess, onError')
      console.log(file.name, '对对对对对对')
      var lastIndex = file.name.lastIndexOf('.')
      console.log('选择的图片路径fileName', lastIndex)
      var extName = lastIndex > -1 ? file.name.slice(lastIndex + 1) : ''
      console.log(extName, 'extNameextNameextName')
      const cosKey = this.generateCosKey('krpano/sc', extName)
      const fileNames = cosKey.split('/').pop()
      ossSignature().then((res) => {
        res = res.data
        const cos = new COS({
          SecretId: res.tmpSecretId,
          SecretKey: res.tmpSecretKey,
          SecurityToken: res.sessionToken, // sts服务下发的临时 SessionToken
          StartTime: res.startTime, // 建议传入服务端时间，可避免客户端时间不准导致的签名错误
          ExpiredTime: res.expiredTime, // 临时密钥过期时间
        })
        cos.putObject(
          {
            Bucket: this.$Bucket, // 对象存储桶名称
            Region: 'ap-guangzhou', // 地域
            Key: cosKey, // 文件路径
            Body: file, // 文件对象
            SliceSize:
              1024 * 1024 * 5 /* 触发分块上传的阈值，超过5MB使用分块上传，小于5MB使用简单上传。可自行设置，非必须 */,
            onProgress: function (progressData) { },
          },
          function (err, data) {
            if (err) {
              console.log('上传失败', err)
            } else {
              console.log('上传成功')
              // that.form.cosKey = cosKey
              console.log(cosKey, 'cosKeycosKey')
              that.form.backgroundMusicUrl = cosKey
              that.isUploading = false
              // that.handleOk(cosKey)
            }
          }
        )
      })
    },
    /** 新增按钮操作 */
    handleAdd(e, type) {
      this.submitLoading = false
      if (type == 1) {
        getObj(e.workId).then(res => {
          this.showIdIndex = 3
          console.log(res, '测试数据===');
          res.data.scenesEditParams = res.data.scenesInfos
          this.form = res.data
          console.log(res, '的点点滴滴');
          this.open = true
          this.formTitle = '修改作品名称'
        })
      } else {
        if (e == 1) {
          console.log(e, '顶顶顶顶')
          this.showIdIndex = 2
          this.reset()
          this.open = true
          this.formTitle = '上传全景'
        } else {
          this.showIdIndex = 1
          this.dataForm = e
          console.log(this.dataForm, 'dataFormdataForm')
          this.showId = 1
          this.reset()
          this.open = true
          this.formTitle = '上传全景'
        }
      }
      // if()

    },
    /** 修改按钮操作 */
    handleUpdate(row, record) {
      this.submitLoading = false
      this.showIdIndex = 1
      this.reset()
      this.dataForm = row
      this.form.scenesEditParams = [record]
      this.showId = 2
      this.open = true
      this.formTitle = '修改场景名称'
    },
    uniqueSceneNames(arr) {
      // 第一步：统计每个sceneName出现的次数
      const nameCounter = {}

      // 第一次遍历，记录每个名称的出现次数
      arr.forEach((item) => {
        if (!item.sceneName) {
          item.sceneName = item.title
        }
        if (!item.extendS1) {
          item.extendS1 = item.originalImageUrl
        }
        const name = item.sceneName
        // 如果是带序号的名称，提取原始名称
        const baseName = name.replace(/\(\d+\)$/, '')
        nameCounter[baseName] = (nameCounter[baseName] || 0) + 1
      })

      // 第二步：处理重复的名称，添加序号
      const usedNames = {}
      return arr.map((item) => {
        let name = item.sceneName
        // 提取不带序号的基础名称
        const baseName = name.replace(/\(\d+\)$/, '')

        // 如果名称只出现一次，不需要修改
        if (nameCounter[baseName] <= 1) {
          return item
        }

        // 找到合适的序号
        let count = 1
        let newName = baseName

        // 检查是否已经使用过该名称或带序号的名称
        while (usedNames[newName]) {
          newName = `${baseName}(${count})`
          count++
        }

        // 标记为已使用
        usedNames[newName] = true

        // 返回修改后的对象
        return {
          ...item,
          sceneName: newName,
        }
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(this.form, '对对对对对对')
      if (this.showIdIndex == 3) {
        // 修改作品名称
        console.log('测试数据更新===')
        if (!this.form.workName) return this.$message.error('作品名称不能为空')
        editSys(this.form)
          .then((res) => {
            this.$message.success('修改成功', 3)
            this.open = false
            this.$emit('ok')
          })
          .finally(() => {
            this.submitLoading = false
            this.showLoading = false
          })
      } else {
        let obj = false
        if (this.form.scenesEditParams.length) {
          this.form.scenesEditParams.forEach((v) => {
            if (!v.sceneName || !v.originalImageUrl) {
              obj = true
            }
          })
        }
        if (this.showIdIndex == 1) {
          if (this.showId == 1) {
            console.log(this.dataForm.scenesInfos, 'this.dataForm.scenesInfos');
            let arr = [...this.dataForm.scenesInfos, ...this.form.scenesEditParams]
            const array = this.uniqueSceneNames(arr)
            console.log(array, 'arrayarray')
            this.dataForm.scenesEditParams = array
            this.submitLoading = true
            this.showLoading = true
            this.$nextTick(() => {
              this.$refs.LoadingPop.init(1)
            })
          } else {
            const objo = this.form.scenesEditParams[0]
            this.dataForm.scenesInfos.forEach((v) => {
              if (v.sceneId == objo.sceneId) {
                v.sceneName = objo.sceneName
              }
            })
            this.dataForm.scenesEditParams = this.dataForm.scenesInfos
          }
          editSys(this.dataForm)
            .then((res) => {
              if (this.showId == 1) {
                this.$message.success('新增成功', 3)
              } else {
                this.$message.success('修改成功', 3)
              }
              this.open = false
              this.$emit('ok')
            })
            .finally(() => {
              this.submitLoading = false
              this.showLoading = false
            })
        } else {
          if (!this.form.workName) return this.$message.error('请输入作品名称')
          console.log(this.originalImageUrl, 'originalImageUrl')
          // this.
          this.form.orderId = ''
          this.form.tenantFirmId = this.$tenantFirmId
          this.submitLoading = true
          addObj(this.form)
            .then((res) => {
              this.$message.success('新增成功', 3)
              this.open = false
              this.$emit('ok')
            })
            .finally(() => {
              this.submitLoading = false
              this.showLoading = false
            })
          console.log(this.form, '顶顶顶顶吗')
        }
      }
    },
  },
}
</script>
<style lang="less" scoped>
.form_sub {
  display: flex;
  justify-content: flex-end;
}

.form_con {
  position: relative;

  .form_sub {
    position: absolute;
    right: 0;
    top: 120px;
  }
}
</style>